import React, { Fragment, useEffect, useState, forwardRef } from 'react';
import { translate } from '../../../../Services/translation';
import { NavLink, useNavigate } from 'react-router-dom';
import { get, post } from '../../../../Services/http';
import DatePicker from "react-datepicker";
import { useSearchParams } from 'react-router-dom';
import { BACKEND_LOGGEND_IN_SHOPID, BACKEND_LOGGEND_IN_ONLYECOM, BACKEND_LOGGEND_IN_ECOMADMIN } from '../../../Services/Api.service';

const PersonalInfo = (props) => {
    const [customerDetails, setcustomerDetails] = useState([]);
    let initialAvailableDate = {
        mindate: new Date(),
        maxdate: new Date()
    }    
    const [availableDates, setavailableDates] = useState(initialAvailableDate);
    const [date, setdate] = useState('');
    const [dateFormatted, setdateFormatted] = useState('');
    const [dateError, setdateError] = useState(false);
    const [zipError, setzipError] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [generalErrors, setgeneralErrors] = useState("");
    const [searchParams] = useSearchParams();  
    const [goBackToSubscriptionList, setgoBackToSubscriptionList]= useState(false);
    const [sendUpdateMailToCustomer, setsendUpdateMailToCustomer] = useState(true);
    const history = useNavigate();


    useEffect(() => {
        const currentFullDate = new Date();
        const availableFullDate = new Date(currentFullDate.getFullYear() - 10, currentFullDate.getMonth(), currentFullDate.getDate());
        setavailableDates({mindate: availableFullDate, maxdate: currentFullDate});  
        
        const returnParam = searchParams.get('return'); 
        if (returnParam) {
            setgoBackToSubscriptionList(true);
        }
    }, []);
    
    useEffect(() => {
        if (props.customerId) {
            get(`/api/customer/${props.customerId}`)        
            .then((response) => response.json())
            .then((result) => {                
                const loggedInShopId = localStorage.getItem(BACKEND_LOGGEND_IN_SHOPID);
                const ecomAdmin = localStorage.getItem(BACKEND_LOGGEND_IN_ECOMADMIN) === "true";
                if (!ecomAdmin && loggedInShopId !== result.nearestOpticianId) {
                    const isOnlyEcom = localStorage.getItem(BACKEND_LOGGEND_IN_ONLYECOM) === "true";
                    history(isOnlyEcom ? '/ecommercelanding' : '/employees');
                }
                result.customerNumber = props.customerId;
                setcustomerDetails(result);

                if (result.lastLensCheckDate !== "") {
                    const fullDateString = result.lastLensCheckDate;
                    const spliDates = fullDateString.split(".");
                    setdate(new Date(spliDates[2], spliDates[1] - 1, spliDates[0])); 
                }                    
            });
        }        
    }, [props.customerId]);

    useEffect(() => {
        if (date && date !== '') {
            const dateValue = new Date(date); 
            const formattedDate = `${String(dateValue.getDate()).padStart(2, '0')}-${String(dateValue.getMonth() + 1).padStart(2, '0')}-${dateValue.getFullYear()}`;
            setcustomerDetails({ ...customerDetails, "lastLensCheckDate": formattedDate}); 
            setdateFormatted(formattedDate);                      
        }      
        setdateError(false);        
    }, [date]);  

    const DatePickerInput = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='completedorderexport__datepicker' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={dateFormatted} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    });

    const setFieldOnChange = (e) => {
        if (e.target.name === "address") {
            customerDetails.deliveryAddress.address = e.target.value;
            setcustomerDetails(customerDetails);
        }

        if (e.target.name === "zipCode") {
            customerDetails.deliveryAddress.zipCode = e.target.value;
            setcustomerDetails(customerDetails);
        }

        if (e.target.name === "city") {
            customerDetails.deliveryAddress.city = e.target.value;
            setcustomerDetails(customerDetails);
        }

        if (e.target.name === "phone") {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
            if (e.target.value.length > 8) {
                e.target.value = e.target.value.substr(0,8);
            }
        }

        setcustomerDetails({ ...customerDetails, [e.target.name]: (e.target.type === "radio" || e.target.type === "checkbox") ? 
        (e.target.checked ? "1" : "") : e.target.value });
    };

    const saveCustomerInfo = () => {
        if (customerDetails.deliveryAddress.zipCode.length !== 4) {
            setzipError(true);
        }
        else {            
            setzipError(false);
            post(`/api/customer/savecustomerinformation/${sendUpdateMailToCustomer.toString()}`, {
                ...customerDetails,            
            })        
            .then((response) => response.json())
            .then((result) => {
                if (result.result === "") {
                    setSuccessMessage(true);
                    setgeneralErrors("");
                    setTimeout(() => {
                        setSuccessMessage(false);
                    }, 1000);
                } else {
                    setgeneralErrors(result.result);
                }                
            })
            .catch((error) => {
               
            });
        }         
    }

    return (
        <Fragment>
            <div className='admin-portal__customer-detail'>
                <div className='go-back-wrapper'>
                    <NavLink to={goBackToSubscriptionList ? "/subscriptionlist" : "/customersearch"} className="go-back-button"> {translate('coptikk.adminportal.customer.backbutton')}</NavLink>
                </div>
                <h2 className='title'>{translate('coptikk.adminportal.customer.detail.title')}:</h2>
                <div className='detail-wrapper'>
                    <p className='sub-title'>{translate('coptikk.adminportal.customer.about')}</p>
                    <div className='row'>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="firstName">
                                {translate('coptikk.adminportal.customer.firstname')}
                            </label>
                            <input
                                className="form__input"
                                id="firstName"
                                name="firstName"
                                type="text"
                                autoComplete="given-name"
                                value={customerDetails.firstName}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="lastName">
                                {translate('coptikk.adminportal.customer.lastname')}
                            </label>
                            <input
                                className="form__input"
                                id="lastName"
                                name="lastName"
                                type="text"
                                autoComplete="family-name"
                                value={customerDetails.lastName}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="email">
                                {translate('coptikk.adminportal.customer.email')}
                            </label>
                            <input
                                className="form__input"
                                id="email"
                                name="email"
                                type="text"
                                autoComplete="email"
                                value={customerDetails.email}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="phone">
                                {translate('coptikk.adminportal.customer.phone')}
                            </label>
                            <input
                                className="form__input"
                                id="phone"
                                name="phone"
                                type="tel"
                                minLength={8}
                                maxLength={8}
                                inputmode="numeric"
                                autoComplete="phone"
                                value={customerDetails.phone}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="nearestOptician">
                                {translate('coptikk.adminportal.customer.nearestoptician')}
                            </label>
                            <input
                                className="form__input"
                                id="nearestOptician"
                                name="nearestOptician"
                                type="text"
                                autoComplete="nearestOptician"
                                value={customerDetails.nearestOptician}
                            />
                        </div>
                        <div className="columns small-12 medium-6">                            
                            <div>
                                <label className="form__label" htmlFor="lastLensCheckDate">
                                    {translate('coptikk.adminportal.customer.lastlenscheckdate')}
                                </label>
                                <div>
                                    {window.innerWidth <= 760 ?
                                        <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={translate("coptikk.register.selectdate")}
                                            locale="nb"
                                            minDate={availableDates.mindate}
                                            maxDate={availableDates.maxdate}
                                            onChange={(date) => setdate(date)}
                                            popperClassName="booking"
                                            customInput={<DatePickerInput />}
                                        /> : <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText={translate("coptikk.register.selectdate")}
                                            locale="nb"
                                            minDate={availableDates.mindate}
                                            maxDate={availableDates.maxdate}
                                            onChange={(date) => setdate(date)}
                                            customInput={<DatePickerInput />}
                                        />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="address">
                                {translate('coptikk.adminportal.customer.address')}
                            </label>
                            <input
                                className="form__input"
                                id="address"
                                name="address"
                                type="text"
                                autoComplete="address"
                                value={customerDetails.deliveryAddress ? customerDetails.deliveryAddress.address : ""}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                        <div className="columns small-12 medium-6">
                            {zipError && <div className='error'>{translate('coptikk.login.invalidzip')}</div>}
                            <label className="form__label" htmlFor="zipCode">
                                {translate('coptikk.adminportal.customer.zipcode')}
                            </label>
                            <input
                                className="form__input"
                                id="zipCode"
                                name="zipCode"
                                type="text"
                                autoComplete="zipCode"
                                value={customerDetails.deliveryAddress ? customerDetails.deliveryAddress.zipCode : ""}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="columns small-12 medium-6">
                            <label className="form__label" htmlFor="city">
                                {translate('coptikk.adminportal.customer.city')}
                            </label>
                            <input
                                className="form__input"
                                id="city"
                                name="city"
                                type="text"
                                autoComplete="city"
                                value={customerDetails.deliveryAddress ? customerDetails.deliveryAddress.city : ""}
                                onChange={(e) => setFieldOnChange(e)}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="column small-12 agree-row">
                            <input
                                type="radio"
                                checked={customerDetails.agreeToUseInformation === "1"}
                                name='agreeToUseInformation'
                                onChange={(e) => setFieldOnChange(e)}
                            ></input>
                            <p>
                                {translate('coptikk.adminportal.customer.agreetoterms')}
                            </p>
                        </div>  
                        <div className="column small-12 agree-row">
                            <input
                                type="checkbox"
                                checked={customerDetails.getInformationOfOffers === "1"}
                                name='getInformationOfOffers'
                                onChange={(e) => setFieldOnChange(e)}
                                className="agree-row-nomargin"
                            ></input>
                            <p>
                                {translate('coptikk.adminportal.customer.agreetooffers')}
                            </p>
                        </div> 
                        <div className="column small-12 agree-row">
                            <input
                                type="checkbox"
                                checked={customerDetails.messageBeforeRunOutOfLenses === "1"}
                                name='messageBeforeRunOutOfLenses'
                                onChange={(e) => setFieldOnChange(e)}
                                className="agree-row-nomargin"
                            ></input>
                            <p>
                                {translate('coptikk.adminportal.customer.agreetoreminder')}
                            </p>
                        </div> 
                    </div>                     
                    <div className='row'>
                        <div className='mailcheckbox-wrapper'>                
                            <input type='checkbox' checked={sendUpdateMailToCustomer} onChange={(e) => setsendUpdateMailToCustomer(e.target.checked)}></input> 
                            <p>{translate("coptikk.adminportal.lenscheckdate.sendupdatemailtext")}</p>                  
                        </div> 
                        <div className='button-wrapper'>                            
                            <a onClick={() => saveCustomerInfo()} className='save-button'>
                                {translate('coptikk.adminportal.customer.save')}
                            </a>
                        </div>
                        {successMessage ? 
                            <div className='success-message'>
                                {translate('coptikk.adminportal.customer.save.message')}
                            </div> : ""
                        }
                        {generalErrors && <div dangerouslySetInnerHTML={{__html: generalErrors}} className='button-wrapper error'></div>}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


export default PersonalInfo;